<template>
    <section class="div-estacao">
        <div class="card-estacao-inline">
            <div>
                <img
                    src="/images/icons/estacao/sol.png"
                    alt="temperatura"
                    id="imgTemp"
                    style="width: 16px"
                />
                <span class="estacao_temperatura"
                    >{{
                        estacaoData ? estacaoData.temperatura : "--"
                    }}°C</span
                >
                | &nbsp;
            </div>
            <div>
                <img
                    src="/images/icons/estacao/umidade.png"
                    alt="umidade"
                    id="imgUmidade"
                    style="width: 16px"
                />
                <span class="estacao_umidade"
                    >{{
                        estacaoData ? estacaoData.umidade : "--"
                    }}%</span
                >
                | &nbsp;
            </div>
            <div>
                <img
                    src="/images/icons/estacao/nuvem.png"
                    alt="chuva"
                    id="imgChuva"
                    style="width: 16px"
                />
                <span class="estacao_chuva">{{
                    estacaoData && estacaoData.chuva > 0
                        ? "Chovendo"
                        : "Sem chuva"
                }}</span>
                <!-- | &nbsp;
            </div>
            <div>
                <img
                    src="/images/icons/estacao/pluviometro.png"
                    alt="pluv"
                    id="imgPluviometro"
                    style="width: 16px"
                />
                <span class="estacao_pluviometro"
                    >{{
                        estacaoData ? estacaoData.pluviometro : "--"
                    }}mm</span
                > -->
            </div>
        </div>
        <div id="estacao_estacao">
            Estação {{ estacaoData ? estacaoData.estacao : "--" }} -
            {{ estacaoData ? dataFormatada(estacaoData.data) : "--" }}
        </div>
    </section>
</template>
<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

export default {
    name: "EstacaoComponent",
    setup() {
        const store = useStore();
        const route = useRoute();
        const estacaoData = ref({});
        const dataFormatada = (data) => {
            const date = new Date(data);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        };

        onMounted(async () => {
            const unidadeId = route.params.unidade;
            estacaoData.value = (await store.dispatch("unidade/getEstacaoByUnidade", unidadeId)).estacao;
        });

        return {
            dataFormatada,
            estacaoData
        };
    },
};
</script>
<style scoped>
.div-estacao {
    background-color: #fff;
    border-radius: 15px;
    height: auto;
    padding: 0.2em;
    align-content: center;
    align-items: center;
    width: auto;
    margin: 2vh;
    color: black;
    font-size: 0.8em;
    font-weight: bolder;
    text-transform: capitalize;
    -webkit-box-shadow: 0px 0px 19px -3px rgba(102, 102, 102, 0.65);
    -moz-box-shadow: 0px 0px 19px -3px rgba(102, 102, 102, 0.65);
    box-shadow: 0px 0px 19px -3px rgba(102, 102, 102, 0.65);
    position: fixed;
    z-index: 1;
    top: 12%;
    right: 0%;
}

.card-estacao-inline {
    padding: 0.5vh;
    display: flex;
    justify-content: space-evenly;
}

#estacao_estacao {
    font-size: 0.7em;
    text-align: center;
}
</style>
